import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "darkGreen" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lightGreen" }, null, -1)
const _hoisted_4 = { class: "wp1200" }
const _hoisted_5 = { class: "flex full" }
const _hoisted_6 = { class: "col2_3 flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col1_3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationList = _resolveComponent("NavigationList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NavigationList, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _hoisted_7
      ])
    ])
  ]))
}